<template>
	<span :title="addressString">
		<!-- <input type="text" class="tbl_int" :value="value" :placeholder="ph" autocomplete="off" style="width:78px;" @input="updateValue" @blur="search(false)" @keyup.enter="enter_search()" :disabled="disabled" /> -->
		<input
			type="text"
			class="tbl_int"
			:value="value"
			:placeholder="ph"
			autocomplete="off"
			style="width:78px;"
			@input="updateValue"
			@blur="search(false)"
			@keyup.enter="keyEnter($event)"
			:disabled="disabled"
			:readonly="disableInput"
			ref="keyword"
			@focus="$event.target.select()"
		/>
		<!-- <input type="text" class="tbl_int" :value="value" :placeholder="ph" autocomplete="off" style="width:78px;" @input="updateValue" @keyup.enter="enter_search()" :disabled="disabled" /> -->
		<button :disabled="disabled" @click="selectPartner()">...</button>
		<!-- <span v-if="showName" class="int_type2"><input v-model="name" v-bind:style="'width:' + nameWidth + 'px;'" class="tbl_int sm_int" readonly @click="selectPartner()"/></span> -->
		<span v-if="showName" class="int_type2"
			><input
				:value="showFullName ? name + ' / ' + full_name : name"
				:title="showFullName ? name + ' / ' + full_name : name"
				v-bind:style="'width:' + nameWidth + 'px;'"
				class="tbl_int sm_int"
				readonly
				:disabled="disabled"
				@click="nameClick()"
				@focus="$event.target.select()"
		/></span>

		<Modal @close="closeModal" v-if="showModal" :draggable="false">
			<template slot="title">Select Partner</template>
			<template slot="body">
				<PartnerPopup :initialKeyword="value" :customerOnly="customerOnly" :vendorOnly="vendorOnly" :limitRecentPO="limitRecentPO" v-on:close="closeModal()" @set-partner="setPartner" />
			</template>
		</Modal>
	</span>
</template>

<script>
import { apiSelectPartner } from '@/api/partner/index.js';
import PartnerPopup from '@/components/common/PartnerPopup';
import Modal from '@/components/common/Modal';

export default {
	data: function() {
		return {
			//code: null,
			name: this.initialName,
			full_name: null,
			// dl: null,
			// desc: null,
			showModal: false,
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
	},
	components: {
		PartnerPopup,
		Modal,
	},
	props: {
		value: String,
		initialName: String,
		addressString: String,

		ph: String,
		showName: {
			type: Boolean,
			default: true,
		},
		showFullName: {
			type: Boolean,
			default: false,
		},
		nameWidth: {
			type: Number,
			default: 300,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		disableInput: {
			type: Boolean,
			default: false,
		},
		customerOnly: {
			type: Boolean,
			default: false,
		},
		vendorOnly: {
			type: Boolean,
			default: false,
		},
		activeOnly: {
			type: Boolean,
			default: false,
		},
		limitRecentPO: {
			type: Boolean,
			default: false,
		},
		nameClickToPopup: {
			type: Boolean,
			default: true,
		},
	},
	watch: {
		initialName: function(newVal) {
			//console.log(newVal);
			this.name = newVal;
		},
		value: function(newVal) {
			if (!newVal) this.name = null;
			//console.log(newVal);
			//this.name = newVal;
		},
	},
	methods: {
		async keyEnter(e) {
			if (this.user.company_id == 'newjigu') {
				await this.search(true);
				e.target.select();
			} else e.target.blur();
			// ? $event.target.blur() : $event.target.select()"
		},
		nameClick() {
			if (this.nameClickToPopup) this.selectPartner();
		},
		updateValue: function(event) {
			this.$emit('input', event.target.value);
			//this.value = event.target.value;
		},
		selectPartner() {
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		async setPartner(partner, enter_tag) {
			console.log(enter_tag);
			//console.log(partner.code, partner.name);
			// this.code = partner.code;
			this.name = partner.name;
			this.full_name = partner.full_name;

			this.$emit('input', partner.code);
			//this.$emit('set-name', partner.name);
			this.$emit('set-partner', partner);
		},
		async enter_search() {
			await this.search(true);
			//if ()
		},
		async search(enter_tag) {
			if (!this.value) return;
			var keyword = this.value.trim();
			if (!keyword) return;

			//console.log('search....', '*' + keyword + '*');
			var param = {
				code: keyword,
				//include_specialty: true,
			};
			if (this.user.company_id == 'newjigu' || this.user.company_id == 'hairplus') param.include_specialty = true;
			//console.log(param);
			//if (this.activeOnly) param.active_yn = 'Y';
			if (this.customerOnly) param.customer_only = true;
			if (this.vendorOnly) param.vendor_only = true;

			const { data } = await apiSelectPartner(param);

			if (data.partner) {
				//console.log(data.partner);
				if (this.activeOnly && data.partner.active_yn == 'N') {
					this.name = null;
					//this.$emit('input', null);
					this.$toast.error('"' + keyword + '" (' + data.partner.name + ') is Not Active');
				} else {
					await this.setPartner(data.partner, enter_tag);
				}
			} else {
				this.name = null;
				//this.$emit('input', null);
				this.$toast.error('Partner Code of "' + keyword + '" Not Found');
				//this.$refs.keyword.select();
			}
		},
		async init() {
			if (this.showFullName) {
				const { data } = await apiSelectPartner({ code: this.value });

				if (data.partner) {
					this.name = data.partner.name;
					this.full_name = data.partner.full_name;
				}
			}
		},
	},
	created() {
		this.init();
	},
};
</script>

<style></style>
